var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_82)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_275_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V13.3333C0 14.8061 1.19391 16 2.66667 16H13.3333C14.8061 16 16 14.8061 16 13.3333V2.66667C16 1.19391 14.8061 0 13.3333 0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1112 5.24909C12.989 4.75818 12.6275 4.37091 12.1676 4.23818C11.3362 4 8.00006 4 8.00006 4C8.00006 4 4.66569 4 3.83252 4.23818C3.37436 4.36909 3.01292 4.75637 2.88904 5.24909C2.66675 6.14 2.66675 7.99999 2.66675 7.99999C2.66675 7.99999 2.66675 9.86 2.88904 10.7509C3.01122 11.2418 3.37266 11.6291 3.83252 11.7618C4.66569 12 8.00006 12 8.00006 12C8.00006 12 11.3362 12 12.1676 11.7618C12.6258 11.6309 12.9873 11.2436 13.1112 10.7509C13.3334 9.86 13.3334 7.99999 13.3334 7.99999C13.3334 7.99999 13.3334 6.14 13.1112 5.24909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93394 9.71425L9.70502 7.99974L6.93394 6.28516V9.71425Z",
    fill: "#FF0000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_275_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.112abec53c3653221a3dd4b3ba9769f1.svg";
export { ForwardRef as ReactComponent };